import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  syncPosSale(id) {
    return axios.post(`${API_URL}/shopify/pos/sales/${id}/sync`, {}, { headers: authHeader() });
  },
  createPosSale(payload) {
    return axios.post(`${API_URL}/shopify/pos/sales`, payload, { headers: authHeader() });
  },
  getPosProducts(params = {}) {
    return axios.get(`${API_URL}/shopify/inventory/pos`, {
      headers: authHeader(),
      params,
    });
  },
  getInventory(params = {}) {
    return axios.get(`${API_URL}/shopify/inventory`, {
      headers: authHeader(),
      params,
    });
  },
  updateOrderStatus(source, id, status) {
    return axios.patch(
      `${API_URL}/shopify/orders/${source}/${id}/status`,
      { status },
      { headers: authHeader() }
    );
  },
  getOrders(params = {}) {
    return axios.get(`${API_URL}/shopify/orders`, {
      headers: authHeader(),
      params,
    });
  },
  syncProducts() {
    return axios.post(`${API_URL}/shopify/products/sync`, {}, { headers: authHeader() });
  },
  syncOrders() {
    return axios.post(`${API_URL}/shopify/orders/sync`, {}, { headers: authHeader() });
  },
  generateToken(payload = {}) {
    return axios.post(`${API_URL}/shopify/oauth/token`, payload, { headers: authHeader() });
  },
  getPaymentModes() {
    return axios.get(`${API_URL}/shopify/payment-modes`, { headers: authHeader() });
  },
};
